import { Injectable } from '@angular/core';
import { LegalizationAlertStatusEnum } from 'src/app/models/enums/legalization-alert-status-enum';
import { LegalizationDocumentStatusEnum } from 'src/app/models/enums/legalization-document-status-enum';
import { LegalizationStatusEnum } from 'src/app/models/enums/legalization-status-enum';

@Injectable({
  providedIn: 'root',
})
export class LegalizationStatusHelperService {
  private readonly alertStatusClassMap = new Map<number, string>([
    [LegalizationAlertStatusEnum.ValidDocument, 'status-label--success'],
    [LegalizationAlertStatusEnum.ApproachingExpiration, 'status-label--warning'],
    [LegalizationAlertStatusEnum.ActionsTaken, 'status-label--warning'],
    [LegalizationAlertStatusEnum.ActionsTakenApproachingExpiration, 'status-label--warning'],
    [LegalizationAlertStatusEnum.AlertDeactivated, 'status-label--warning'],
    [LegalizationAlertStatusEnum.ExpirationDateReached, 'status-label--danger'],
    [LegalizationAlertStatusEnum.ActionsTakenExpirationDateReached, 'status-label--danger'],
  ]);

  private readonly statusClassMap = new Map<number, string>([
    [LegalizationStatusEnum.Draft, 'status-label--none'],
    [LegalizationStatusEnum.ReadyForLegalization, 'status-label--default'],
    [LegalizationStatusEnum.InProgress, 'status-label--warning'],
    [LegalizationStatusEnum.AwaitingStatement, 'status-label--warning'],
    [LegalizationStatusEnum.AwaitingPermit, 'status-label--warning'],
    [LegalizationStatusEnum.MissingDocuments, 'status-label--warning'],
    [LegalizationStatusEnum.Approved, 'status-label--success'],
    [LegalizationStatusEnum.Rejected, 'status-label--danger'],
  ]);

  private readonly documentStatusClassMap = new Map<number, string>([
    [LegalizationDocumentStatusEnum.Corrected, 'status-label--none'],
    [LegalizationDocumentStatusEnum.RequiresCorrection, 'status-label--danger'],
    [LegalizationDocumentStatusEnum.Valid, 'status-label--success'],
    [LegalizationDocumentStatusEnum.ToBeVerified, 'status-label--warning'],
  ]);

  getAlertStatusClass(statusId: number): string {
    return statusId ? this.alertStatusClassMap.get(statusId) || '' : '';
  }

  getStatusClass(statusId: number): string {
    return statusId ? this.statusClassMap.get(statusId) || '' : '';
  }

  getDocumentStatusClass(statusId: number): string {
    return statusId ? this.documentStatusClassMap.get(statusId) || '' : '';
  }
}
